const actionTypeIdentifier = 'CE257173-7AA8-447D-93F1-A97A32B0B768'; //this is a newid

export const getAllOrder = `GET-ALL-EXTERNAL-ORDER-${actionTypeIdentifier}`;
export const setAllOrderError = `SET-ALL-EXTERNAL-ORDER-ERROR-${actionTypeIdentifier}`;
export const setAllOrderColSearchStr = `SET-ALL-EXTERNAL-ORDER-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const sortAllOrderItems = `SORT-ALL-EXTERNAL-ORDER-${actionTypeIdentifier}`;
export const setAllOrderPageSize = `SET-ALL-ORDER-PAGESIZE-${actionTypeIdentifier}`;
export const setAllOrderFilter = `SET-ALL-ORDER-FILTER-${actionTypeIdentifier}`;
export const applyAllOrderFilter = `APPLY-ALL-ORDER-FILTER-${actionTypeIdentifier}`;
export const applyAllOrderStatusFilter = `APPLY-ALL-ORDER-STATUS-FILTER-${actionTypeIdentifier}`;
export const setDefaultAllOrder = `SET-DEFAULT-ALL-ORDER-${actionTypeIdentifier}`;
export const setFormLoading = `SET-FORM-LOADING-${actionTypeIdentifier}`;
